export default "__VITE_ASSET__5deCNlDQ__"